/* Skeleton shown until the order list arrives. Mirrors the real card's shape —
   number, timestamp, tracker, store block, directions — so the page does not
   jump when it loads.

   ⚠ The isWebOrder / isDelivery branches are unchanged: a kiosk or table order
   has no tracker or store block to skeleton, and a delivery order has no
   directions button. */
export default function OrderLoader(props) {

    const isWebOrder = props.urlConfig.Type === '' || props.urlConfig.Type === null || props.urlConfig.Type === 'null' || props.urlConfig.Type === 'web' ? true : false;
    const isDelivery = props.urlConfig.MenuType === 'delivery';

    if (isWebOrder) { // Web Ordering
        return (
            <div className="wo-ord" aria-hidden="true">
                <div className="wo-ord__head">
                    <span className="wo-skel wo-skel--ordNum"></span>
                    <span className="wo-skel wo-skel--ordWhen"></span>
                </div>
                <div className="wo-ordSkel">
                    <span className="wo-skel wo-skel--ordTrack"></span>
                    <span className="wo-skel wo-skel--ordText"></span>
                </div>
                <span className="wo-skel wo-skel--ordStore"></span>
                { !isDelivery && <span className="wo-skel wo-skel--ordDir"></span> }
            </div>
        )
    } else { // Not Web Order
        return (
            <div className="wo-ord" aria-hidden="true">
                <div className="wo-ord__head">
                    <span className="wo-skel wo-skel--ordNum"></span>
                </div>
            </div>
        )
    }
}
